var body = $('body');
var tagArr = [];

$(function () {
    'use strict';

    zhSearch();

    getCategory();
    queryAllTopic();
    fetchAllTag();

    $('#ghost-portal-root').remove();

    featured();
    video();
    gallery();
    table();
    mobileMenu();

    // 头部样式
    headerToggle();

    // 下拉菜单显示隐藏
    $('.navbar-nav-topbar-list ul li').hover(
        function () {
            // 获取当前的 选中元素下的 ID
            const currentID = $(this)
                .find('.navbar-nav-childre-fluid')
                .prop('id');
            // 整体屏幕宽度
            const innerWidth = window.innerWidth;
            // 当前dom宽度
            const domWidth = $(this).width();
            // 元素距左边
            const offsetLeft = $(this).offset().left;
            // 实际上的距离
            const marginRight =
                innerWidth / 2 - offsetLeft - domWidth / 2 - 6.5;
            // 设置三角形下标的位置
            // document.styleSheets[0].addRule('#' + currentID + ':after', 'margin-right:' + marginRight + 'px !important');

            $(this).find('.navbar-nav-children-info').stop(true).slideDown(100);
        },
        function () {
            $(this).find('.navbar-nav-children-info').stop(true).slideUp(100);
        }
    );

    $(window).resize(function () {
        // 方案优势 移动端下的距离调整
        $('.navbar-burger').css(
            'display',
            $(window).width() <= 1024 ? 'block' : 'none'
        );

        if ($(window).width() > 1024) {
            $('.mobile-menu.menu-opened').css('display', 'none');
        }
    });
});

document.addEventListener('lazyloaded', function (e) {
    'use strict';
    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    if ($(e.target).parent('.site-cover').length) {
        $(e.target).parent().jarallax(options).addClass('initialized');
    }
});

function formatDate(date) {
    if (date) {
        return new Date(date).toLocaleDateString('cn', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }
    return '';
}

// // 获取所有的 分类
function fetchAllTag() {
    var url =
        siteUrl +
        '/ghost/api/v4/content/tags/?key=' +
        gh_search_key +
        '&limit=all';

    $.get(url, function (res) {
        var response = res.tags;
        tagArr = response;
        if (window.location.pathname !== '/') {
            var currentInfo = response.filter(
                (item) => item.url === window.location.href
            );

            if (currentInfo[0] && currentInfo[0].name) {
                $('#nav-title').text(currentInfo[0].name);
            }
        }
    });
}

// 中文搜索支持
function zhSearch() {
    // 中文搜索支持
    var searchInput = $('.search-field');
    var searchButton = $('.search-button');
    var searchResult = $('.search-result');

    var flexIndexZh = null;
    var flexIndexEn = null;

    trySearchFeature();

    function trySearchFeature() {
        if (
            typeof gh_search_key !== 'undefined' &&
            typeof siteUrl !== 'undefined'
        ) {
            getAllPosts(siteUrl, gh_search_key);
        }
    }

    function getAllPosts(host, key) {
        var api = new GhostContentAPI({
            url: host,
            key: key,
            version: 'v3',
        });

        var allPosts = [];
        var docOption = {
            doc: {
                id: 'id',
                field: [
                    'title',
                    'html',
                    'custom_excerpt',
                    'content',
                    'meta_title',
                    'meta_description',
                    'excerpt',
                ],
            },
        };
        var flexOptionsZh = {
            encode: false,
            tokenize: function (str) {
                return str.replace(/[\x00-\x7F]/g, '').split('');
            },
        };

        var flexOptionsEn = {
            encode: 'advanced',
            tokenize: 'forward',
        };

        api.posts
            .browse({
                limit: 'all',
                fields: 'id, title, url, published_at, custom_excerpt, html, content, meta_title, meta_description, excerpt',
            })
            .then(function (posts) {
                for (var i = 0, len = posts.length; i < len; i++) {
                    allPosts.push(posts[i]);
                }

                flexIndexZh = new FlexSearch(
                    Object.assign({}, flexOptionsZh, docOption)
                );
                flexIndexZh.add(allPosts);

                flexIndexEn = new FlexSearch(
                    Object.assign({}, flexOptionsEn, docOption)
                );
                flexIndexEn.add(allPosts);
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    searchInput.keyup(function (e) {
        const enterValue = e.target.value;
        if (enterValue.length > 0 && flexIndexEn && flexIndexZh) {
            const resultsZh = flexIndexZh.search(enterValue);
            const resultsEn = flexIndexEn.search(enterValue);
            const results = resultsZh.concat(resultsEn);
            var output = '';
            results.forEach(function (post) {
                output +=
                    '<div class="search-result-row">' +
                    '<a class="search-result-row-link" href="' +
                    post.url +
                    '">' +
                    '<div class="search-result-row-title">' +
                    post.title +
                    '</div><div class="search-result-row-excerpt">' +
                    formatDate(post.published_at) +
                    '</div></a>' +
                    '</div>';
            });
            searchResult.html(output);
        }
        if (enterValue.length > 0) {
            searchButton.addClass('search-button-clear');
        } else {
            searchButton.removeClass('search-button-clear');
        }
    });

    $('.search-form').on('submit', function (e) {
        e.preventDefault();
    });

    searchButton.on('click', function () {
        if ($(this).hasClass('search-button-clear')) {
            searchInput.val('').focus().keyup();
            searchButton.removeClass('search-button-clear');
            searchResult.empty();
            searchInput.blur();
        }
    });

    searchInput.on('blur', function () {
        searchInput.val('');
        searchButton.removeClass('search-button-clear');
        var timer = setTimeout(function () {
            searchResult && searchResult.empty();
            clearTimeout(timer);
        }, 500);
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            searchInput.val('').focus().keyup();
        }
    });
}

// 获取的推荐文章
function queryAllTopic() {
    var recommendedDoc = $('#recommended-doc');
    var url =
        siteUrl +
        '/ghost/api/v4/content/posts/?key=' +
        gh_search_key +
        '&limit=10&order=published_at%20asc';
    // <span class="time">${formatDate(
    //   post.published_at
    // )}</span>

    $.get(url, function (res) {
        const response = res.posts.slice(0, 5);
        var output = '';
        response.forEach(function (post, index) {
            output += `
            <li class="recommend-essay list-item">
                <a href="${post.url}">
                    <div>
                        <p class="text-recommended">${post.title}</p>
                    </div>
                </a>
            </li>
            `;
        });
        recommendedDoc.html(output);
    });
}

function getCategory() {
    var categoryItem = $('#category');
    var output = '';
    var pathName = window.location.pathname;
    var pathnameArr = [];

    // const sm_map = [
    //   'ya-shu-ca',
    //   'shang-mi-chan-pin',
    //   'shang-mi-gai-zao',
    //   'shang-mi-fang-an',
    // ];
    // const zc_map = [
    //   'zheng-ce-fa-gui-yi-ju',
    //   'ce-ping-dui-xiang-biao-zhun',
    //   'ce-ping',
    //   'yu-ping-gu-xi-tong',
    // ];

    var NEWS_LIST = [
        {
            name: '公司新闻',
            type: 'company-news',
            show: true,
        },
        {
            name: '行业新闻',
            type: 'industry-news',
            show: true,
        },
        {
            name: '网络安全',
            type: 'network-security',
            show: true,
        },
        {
            name: '博客',
            type: 'blog',
            show: true,
        },
        {
            name: '技术支持',
            type: 'tech-support',
            show: true,
        },
        {
            name: '常见问答',
            type: 'faq',
            show: true,
        },
        {
            name: '亚数 CA',
            type: 'ya-shu-ca',
            show: false,
        },
        {
            name: '商密产品',
            type: 'shang-mi-chan-pin',
            show: false,
        },
        {
            name: '商密改造',
            type: 'shang-mi-gai-zao',
            show: false,
        },
        {
            name: '商密方案',
            type: 'shang-mi-fang-an',
            show: false,
        },
        {
            name: '政策法规依据',
            type: 'zheng-ce-fa-gui-yi-ju',
            show: false,
        },
        {
            name: '测评对象标准',
            type: 'ce-ping-dui-xiang-biao-zhun',
            show: false,
        },
        {
            name: '测评内容流程',
            type: 'ce-ping',
            show: false,
        },
        {
            name: '预评估系统',
            type: 'yu-ping-gu-xi-tong',
            show: false,
        },
    ];

    NEWS_LIST.forEach((item, index) => {
        var href = NEWS_LIST[index].type + '/';
        var isShow = NEWS_LIST[index].show ? 'inline-block' : 'none';
        pathnameArr.push(href);
        output +=
            '<li class="classify-tag" id="' +
            NEWS_LIST[index].type +
            '" style="display:' +
            isShow +
            '"><a href="/' +
            href +
            '">' +
            NEWS_LIST[index].name +
            '</a></li>';
        categoryItem.html(output);

        if (pathName === '/') {
            $('.classify-tag:first-of-type').addClass('active');
            const text = $('.classify-tag:first-of-type').text();
            $('#nav-title').html(text);
        }

        if (pathName === href || pathName.indexOf(NEWS_LIST[index].type) > -1) {
            const text = `${NEWS_LIST[index].name}`;
            $('#nav-title').html(text);
        }

        pathnameArr.map((item, index) => {
            if (item === pathName || pathName.includes(item)) {
                $(`.classify-tag:nth-of-type(${index + 1})`).addClass('active');
            }
        });
    });
}

// tag
function featured() {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');

    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });
}

function table() {
    'use strict';
    if (body.hasClass('post-template') || body.hasClass('page-template')) {
        var tables = $('.post-content').find('.table');
        tables.each(function (_, table) {
            var labels = [];

            $(table)
                .find('thead th')
                .each(function (_, label) {
                    labels.push($(label).text());
                });

            $(table)
                .find('tr')
                .each(function (_, row) {
                    $(row)
                        .find('td')
                        .each(function (index, column) {
                            $(column).attr('data-label', labels[index]);
                        });
                });
        });
    }
}

function mobileMenu() {
    'use strict';
    $('.burger').on('click', function () {
        $('body').toggleClass('menu-opened');
    });
}

// 页面滚动 样式调整
$(window).scroll(function () {
    headerToggle();
});

// 头部样式控制
function headerToggle() {
    var sTop = $(document).scrollTop();
    // banner的高度
    var sHeight = $('.site-header').height();
    if (sTop > sHeight) {
        $('.site-header').addClass('blueGrey');
    } else if (sTop < sHeight) {
        $('.site-header').removeClass('blueGrey');
    }
}

// 切换显示方法
function toogleShow(className1, className2, dom) {
    $(dom).addClass('active').siblings().removeClass('active');
    const id = $(dom).attr('id');
    if (id === 'gm-tab') {
        window.location.href = '/product/sm-cert';
    } else {
        $('.' + className1 + ' .' + className2 + '')
            .eq($(dom).index())
            .addClass('active')
            .siblings()
            .removeClass('active');
    }
}

$('#tsl-menu li').click(function () {
    toogleShow('tsl-item', 'nav-item-children-tab-contain', this);
});

$('#solution-menu li').click(function () {
    toogleShow('solution-item', 'nav-item-children-tab-contain', this);
});

// 显示移动端菜单
$('.navbar .navbar-burger').click(function () {
    $('#mobile-menu').toggleClass('menu-opened');
});

// 移动端菜单操作
$('.mobile-menu .mobile-nav .mobile-dropdown a').click(function () {
    $(this).parent().toggleClass('open');
});

$('.mobile-menu .mobile-nav .open .mobile-dropdown-menu li a').click(
    function () {
        $(this).toggleClass('open');
    }
);

$('.mobile-menu .mobile-nav .open .mobile-dropdown-menu li.open a').click(
    function () {
        $(this).toggleClass('open');
    }
);

// 在线咨询
$('.open-contact-dialog').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            navigator.userAgent.substr(0, 4)
        )
    ) {
        $('.nb-icon-wrap-base.nb-icon-customer').trigger('click');
    } else {
        $('#nb_icon_groups > ins:eq(0)').trigger('click');
        _hmt.push(['_trackEvent', '沟通']);
    }
    return false;
});

// 获取技术支持
$('.open-contact-dialog-support').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    // 技术支持
    $('#nb_icon_groups > ins:eq(3)').trigger('click');
    _hmt.push(['_trackEvent', '支持']);
    return false;
});
